import { Badge } from 'components/Badge/Badge'
import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import { NavBar } from 'components/NavBar/NavBar'
import { useState } from 'react'
import { Button, Flex, H1WithBack, MainHeadline, PageWrapper } from 'styling/GlobalStyles'
import { BodyText, OtherText } from 'styling/Typography'
import { ITaskRow, TASK_PRIORITY_COLORS } from 'types/operationsTasks.interface'

import { MOCK_TASKS } from './operationsTasksData'
import { EvenCell, EvenTableWrapper } from './OperationsTasks.styled'
import { AddTaskModal } from './AddTaskModal'

const columns: IHonestTableColumn<ITaskRow>[] = [
    {
        id: 'taskTemplate',
        header: 'Task template',
        sortable: true,
        sticky: true,
        cell: (item) => (
            <EvenCell>
                <BodyText weight='600'>{item.taskTemplate}</BodyText>
            </EvenCell>
        ),
    },
    {
        id: 'department',
        header: 'Department',
        sortable: true,
        cell: (item) => (
            <EvenCell>
                <BodyText>{item.department}</BodyText>
            </EvenCell>
        ),
    },
    {
        id: 'location',
        header: 'Location',
        sortable: true,
        cell: (item) => (
            <EvenCell>
                <BodyText>{item.location ?? '—'}</BodyText>
            </EvenCell>
        ),
    },
    {
        id: 'priority',
        header: 'Priority',
        sortable: true,
        cell: (item) => (
            <EvenCell>
                <Badge hexColor={TASK_PRIORITY_COLORS[item.priority]}>
                    <BodyText>{item.priority}</BodyText>
                </Badge>
            </EvenCell>
        ),
    },
    {
        id: 'assignment',
        header: 'Assignment',
        sortable: true,
        cell: (item) => (
            <EvenCell>
                <BodyText>{item.assignment}</BodyText>
                {item.assignees && <OtherText grey>{item.assignees}</OtherText>}
            </EvenCell>
        ),
    },
    {
        id: 'startAt',
        header: 'Start at',
        sortable: true,
        cell: (item) => (
            <EvenCell>
                <BodyText>{item.startAt}</BodyText>
            </EvenCell>
        ),
    },
    {
        id: 'evidenceRequired',
        header: 'Evidence',
        cell: (item) => (
            <EvenCell>
                <BodyText>{item.evidenceRequired ? 'Required' : '—'}</BodyText>
            </EvenCell>
        ),
    },
]

export const OperationsTasks = () => {
    const [modalOpen, setModalOpen] = useState(false)

    return <>
        <NavBar />
        <PageWrapper>
            <Flex between width='100%' mb='16'>
                <H1WithBack arrow title='Tasks' />
                <Button orange onClick={() => setModalOpen(true)}>Add</Button>
            </Flex>
            <EvenTableWrapper>
                <HonestTable
                    columns={columns}
                    data={MOCK_TASKS}
                    keyField='id'
                />
            </EvenTableWrapper>
        </PageWrapper>
        {modalOpen && <AddTaskModal closeModal={() => setModalOpen(false)} />}
    </>
}
